module.exports = __webpack_public_path__ + "public/img/logo.8c1e6a58.jpg";